import axios from "axios";
import { API_ENDPOINTS } from "../../../helpers/config";

export const OrderService = {
  getAllOrders: async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_API_URL + API_ENDPOINTS.ORDERS.GET_ALL_ORDERS
      );
      return response.data;
    } catch (err) {
      console.log(err);
    }
  },
};
